<template>
  <v-avatar
    :color="backgroundColor"
    :size="size.toString()"
    :style="{fontSize: fontSize, fontColor: fontColor}"
  >
    <v-img
      v-if="avatarCache"
      :src="avatarImage"
    />
    <template v-else>
      {{ nameAbbreviation }}
    </template>
  </v-avatar>
</template>

<script>
  import settings from '@/settings'
  import md5 from 'js-md5'

  export default {
    // components: {Avatar},
    props: {
      size: {
        type: Number,
        default: 40
      },
      profile: {
        type: Object,
        default: undefined
      }
    },
    data: () => ({
      serial: null,
      colors: [
        'red', 'pink', 'purple', 'deep-purple',
        'indigo', 'blue', 'light-blue', 'cyan', 'teal',
        'green', 'light-green', 'lime', 'amber',
        'orange', 'deep-orange', 'brown', 'grey', 'blue-grey'
      ]
    }),
    computed: {
      avatarCache () {
        if (this.profile) {
          return this.profile.avatar_cache
        } else if (this.profile === undefined) {
          return this.myProfile.avatar_cache
        } else return ''
      },
      avatarImage () {
        const url = settings.ApiUrl.replace(/XuhB3Clo\/v1\//g, '')
        return url + 'avatar/' + md5(this.profile.id) + '.jpeg?ca=' + this.avatarCache
      },
      myProfile () {
        return this.$store.getters['auth/profile']
      },
      nameAbbreviation () {
        const parts = this.username.split(/[ -]/)
        let initials = ''

        // get the initial of all the parts
        parts.forEach((part) => {
          initials += part.charAt(0)
        })

        if (initials.length > 3 && initials.search(/[A-Z]/) !== -1) {
          initials = initials.replace(/[a-z]+/g, '')
        }

        return initials.substring(0, 3).toUpperCase()
      },
      username () {
        if (this.profile) {
          return this.profile.first_name_en + ' ' + this.profile.last_name_en
        } else if (this.profile === undefined) {
          return this.myProfile.first_name_en + ' ' + this.myProfile.last_name_en
        } else {
          return '?'
        }
      },
      backgroundColor () {
        return this.avatarCache ? undefined : this.colors[(this.username.length) % this.colors.length]
      },
      fontSize () {
        return Math.floor(this.size / 2.5).toString() + 'px'
      },
      fontColor () {
        return this.backgroundColor + '-11'
      }
    }
  }
</script>

<style scoped>

</style>
